module.exports = __webpack_public_path__ + "img/new-center-title.abf73b73.png";